import React from "react";
import PropTypes from "prop-types";
import {FormFeedback, Input, InputGroup, InputGroupAddon, InputGroupText} from "reactstrap";
import {isUndefined} from "lodash";
import getWorkshopSetting from "../../utils/getWorkshopSetting";
import {PRICE_TYPE_GROSS, PRICE_TYPE_NET} from "../../utils/price";
import {useTranslation} from "react-i18next";

function InputNumberFloat(props) {
  const { t } = useTranslation()
  const trimValue = (value) => {
    let v = parseFloat(value)
      .toFixed(props.digits)
      .replace(/0+$/, '')

    if(v.split('.')[1].length === 0){
      v = v.replace('.', '')
    }

    return v
  }

  const inputRef = React.createRef();
  const [value, setValue] = React.useState((props.value === undefined || props.value === null || props.value === '') ? '' : trimValue(props.value));

  React.useEffect(() => {
    if(value !== props.value){
      setValue((props.value === undefined || props.value === null || props.value === '') ? '' : trimValue(props.value))
    }
  }, [props.value]);

  const getAppendText = () => {
    if(isUndefined(props.appendText)){
      return getWorkshopSetting('currencyCode');
    }

    return props.appendText;
  }

  const onChange = (value) => {
    if(!isUndefined(props.min) && value < props.min){
      value = props.min;
    }
    if(!isUndefined(props.max) && value > props.max){
      value = props.max;
    }
    setValue(value)

    props.onChange(value.length === 0 ? '' : parseFloat(value))
  };

  const input = <Input
    innerRef={inputRef}
    invalid={!!props?.errors}
    bsSize={props.size}
    placeholder={props.placeholder}
    disabled={props.disabled}
    className={"text-right " + props.className}
    autoFocus={props.autoFocus}
    onFocus={e => e.target.select()}
    onBlur={() => onChange(value === '' ? '' : parseFloat(value).toFixed(props.digits))}
    value={value}
    onChange={e => {
      let v = e.target.value.replace(',', '.');
      if(v === '.'){
        v = '0.'
      }

      if (v === '' || /^(-?)\d*\.?\d*$/.test(v)) {
        setValue(v);
      }
    }}
    onKeyDown={e => {
      switch (e.key) {
        case 'Enter': {
          onChange(value === '' ? '' : parseFloat(value).toFixed(props.digits))
          break;
        }
        case 'Escape': {
          onChange(props.value)
          break;
        }
      }
    }}
  />

  if(!getAppendText()){
    return input;
  }

  return <InputGroup size={props.size}>
    {input}
    <InputGroupAddon addonType="append"><InputGroupText>{getAppendText()}</InputGroupText></InputGroupAddon>
    {props.showPrice && <InputGroupAddon
      className="cursor-pointer"
      addonType={'append'}
      onClick={() => props.onShowPriceChange(props.showPrice === PRICE_TYPE_NET ? PRICE_TYPE_GROSS : PRICE_TYPE_NET)}
    >{t(`common:${props.showPrice}`)}</InputGroupAddon>}
    {!props.hideErrorMessage && <FormFeedback>{props.errors?.join('; ')}</FormFeedback>}
  </InputGroup>
};

InputNumberFloat.defaultProps = {
  placeholder: '',
  className: '',
  size: 'sm',
  autoFocus: false,
  disabled: false,
  digits: 2,
  hideErrorMessage: false,
  showPriceChangeable: false,
};

InputNumberFloat.propTypes = {
  showPrice: PropTypes.oneOf([PRICE_TYPE_NET, PRICE_TYPE_GROSS]),
  onShowPriceChange: PropTypes.func,
  digits: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  placeholder: PropTypes.any,
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  appendText: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']).isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  hideErrorMessage: PropTypes.bool,
};

export default InputNumberFloat;
